import React, { memo } from 'react';
import dayjs from 'dayjs';

const DateRenderComponent = ({ value }) => {
  const date = dayjs(value);
  const dateDisplay = (date && date.isValid() && date.format('MM/DD/YYYY')) || '';

  return <span>{dateDisplay}</span>;
};

/** Date render component. */
export const DateRender = memo(DateRenderComponent);
